export default "__VITE_ASSET__Nxs6lLhD__"